var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenFullscreen = function SvgOpenFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.286 64.286H0V100h35.714V85.714H14.286V64.286ZM0 35.714h14.286V14.286h21.428V0H0v35.714Zm85.714 50H64.286V100H100V64.286H85.714v21.428ZM64.286 0v14.286h21.428v21.428H100V0H64.286Z"
  })));
};
export default SvgOpenFullscreen;